import { Injectable } from '@angular/core';
import { IFormMasterBuilder } from 'i2g-ng-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class SelectAccountFormBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    SELECT_ACCOUNT: 'selectAccount',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(): FormGroup {
    const formKeys = this.FORM_KEYS;

    return this._formBuilder.group({
      [formKeys.SELECT_ACCOUNT]: [null, [Validators.required]],
    });
  }
}
